import { render, staticRenderFns } from "./ItemListAuctionExhibitLayout.vue?vue&type=template&id=187468f8&scoped=true"
import script from "./ItemListAuctionExhibitLayout.vue?vue&type=script&lang=js"
export * from "./ItemListAuctionExhibitLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187468f8",
  null
  
)

export default component.exports